import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button, Spinner } from 'react-bootstrap'
import { endpoint } from "../../utils/api";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faUpload);

const TemplatesTable = ({templates, users, chosenDepartment}) => { 
    const [IDLoading, setIDLoading] = useState(false);  

    const click = async (id) => {

        return Word.run(async (context) => {     
    
           let url = endpoint + "/templates/template/sections/"+id;
           fetch(url, 
            {
              headers: {
                 Authorization: 'Bearer '+ localStorage.token,
                 DepartmentName: chosenDepartment
             }
            }).then(function async (response){
                console.log(response)
                response.json().then(function (data) {
                    
                    data.sections.map((section) => {
                        if(section.file !== null) {
                            let text = Buffer.from(section.file, 'hex').toString('utf8');
                            context.document.body.insertOoxml(text, "End")
                        }
          
                    }) 
                    context.sync();  
                    setIDLoading("");
                });                
                       
             }
               )
            });
        };
        
        /*
      {templates[template].tags.map((tag) => {
            return <Badge bg="secondary">{tag}</Badge>
        })}*/    

    return (
        <Table striped bordered hover>
        <thead>
            <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Author</th>
            <th>Insert</th>
            </tr>
        </thead>
        <tbody>
        {Object.keys(templates).map((template) => {
                return <tr>
                <td>{templates[template].name}</td>
                <td>{templates[template].description}</td>
                <td>{Object.keys(users).map(user => {
                        if (users[user]._id === templates[template].author){
                            return users[user].name
                        }
                    })}
                </td>
                <td><Button className="primary-button border-button" onClick={ () => {click(templates[template]._id); setIDLoading(templates[template]._id) }} disabled={templates[template]._id === IDLoading}>
                    {templates[template]._id !== IDLoading ? 
                    <FontAwesomeIcon icon={faUpload}  size='1x' className='all-font-icons' />
                    :
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        variant="light"
                    />
                    }
                    </Button></td>
            </tr>       
            })}
        </tbody>
    </Table>
    )
}

export default TemplatesTable
